import React from 'react'

const Industrial_Tools = () => {
  return (
    <div>
        {/* collapseEight */}
        <div className="accordion-item mb-2">
        <h2 className="accordion-header" id="headingEight">
            <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
            data-bs-toggle="collapse" data-bs-target="#collapseEight"
            aria-expanded="false" aria-controls="collapseEight">
            Industrial Tools
            <span className="toggle-icon ms-auto"></span>
            </button>
        </h2>
        <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionCourses">
            <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
            <strong>Git</strong>:
            <ul>
                <li>Version Control •Git Introduction</li>
                <li>Git Installation</li>
                <li>Create and Clone Repository</li>
                <li>Commonly used commands in Git</li>
                <li>Working with Remote Repository</li>
                <li>Branching and merging in Git</li>
                <li>Merge Conflicts</li>
                <li>Stashing, Rebasing, Reverting and Resetting</li>
                <li>Git Workflows</li>
            </ul>

            <strong>Jenkins</strong>:
            <ul>
                <li>Introduction to Continuous</li>
                <li>Integration</li>
                <li>Jenkins Architecture</li>
                <li>Plugin Management in Jenkins</li>
                <li>Jenkins Security Management</li>
                <li>Notification in Jenkins</li>
                <li>Jenkins Master-slave architecture</li>
                <li>Jenkins Delivery Pipeline</li>
                <li>Jenkins Declarative Pipeline</li>
                <li>CI/CD Pipeline</li>
                <li>Integrate Git with Jenkins</li>
                <li>Integrate Maven with Jenkins</li>
            </ul>

            <strong>Jira</strong>:
            <ul>
                <li>Introduction to JIRA</li>
                <li>Installation</li>
                <li>Create project, Scheme, Issues</li>
                <li>Add Users</li>
                <li>Jira Dashboard and Gadgets</li>
                <li>Kanban Boards and Scrum</li>
                <li>Write Test Cases, Test Cycles</li>
                <li>Defect / Bug Templates</li>
                <li>Logging defects</li>
                <li>Defect Lifecycle</li>
                <li>Searching Defects and doing bulk Changes</li>
                <li>Search Filters</li>
                <li>Advanced Search using JQL</li>
                <li>Jira Query Language</li>
                <li>Generating Reports</li>
                <li>Types of Reports</li>
                <li>Backlog</li>
                <li>Agile Project Monitoring and reporting with Jira</li>
            </ul>

            <strong>Maven</strong>:
            <ul>
                <li>Introduction to Maven</li>
                <li>Maven Architecture</li>
            </ul>
            </div>
        </div>
        </div>

        {/* collapseNine */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingNine">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine"aria-expanded="false" aria-controls="collapseNine">Software Project Management (SPM)<span className="toggle-icon ms-auto"></span></button>
            </h2>
            <div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                <ul>
                    <li>Introduction to Project Management</li>
                    <li>Scope of Project</li>
                    <li>Project Scheduling</li>
                    <li>Team Responsibilities and Activities</li>
                    <li>Test Cases and Cost Implications</li>
                    <li>UATS (User Acceptance Testing)</li>
                    <li>SDLC (Software Develpoment Life Cycle)</li>
                </ul>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Industrial_Tools